import { useEffect, useState } from "react";

export const numberFormatter = (
  num: any,
  decimal: number = 1,
  unit: string = "",
  negativeNoBracket:boolean=false
) => {
  if (num == 0) {
    return (unit + 0).trim();
  }
  let returnValue = "";
  let isNegative = num < 0;
  num = Math.abs(num);
  if (num > 0 && num < 1) {
    returnValue = (Number((num * 100).toFixed(decimal)) / 100).toFixed(decimal); // if value < 1000, nothing to do
  } else if (num > 999 && num < 1000000) {
    returnValue = (num / 1000).toFixed(decimal) + "K"; // convert to K for number from > 1000 < 1 million
  } else if (num >= 1000000 && num < 1000000000) {
    returnValue = (num / 1000000).toFixed(decimal) + "M"; // convert to M for number from >= 1 million
  } else if (num >= 1000000000) {
    //convert to B for number from >= 1B
    returnValue = (num / 1000000000).toFixed(decimal) + "B";
  } else {
    returnValue = num.toFixed(decimal);
  }
  return (unit + (isNegative ?(negativeNoBracket?returnValue:`(${returnValue})`) : returnValue)).trim();
};


export const numberFormatterInK = (
  num: any,
  decimal: number = 1,
  showUnit: boolean = true,
  unit: string = ""
) => {
  if (num == 0) {
    return (unit + 0).trim();
  }
  let returnValue = "";
  let isNegative = num < 0;
  num = Math.abs(num);
  if (num > 999) {
    returnValue = (num / 1000).toFixed(decimal) + (showUnit ? "K" : ""); // convert to K for number from > 1000 < 1 million
  } else if (num > 0 && num < 1) {
    returnValue = (Number((num * 100).toFixed(decimal)) / 100).toFixed(decimal); // if value < 1000, nothing to do
  } else {
    returnValue = num.toFixed(decimal);
  }
  return (unit + (isNegative ? `(${returnValue})` : returnValue)).trim();
};

export const numberFormatterForCPGraph = (num: any, decimal: number = 1, unit: string = '') => {
  if (num == 0) {
      return (unit + 0).trim();
  }
  let returnValue = '';
  let isNegative = num < 0;
  num = Math.abs(num);
  if (num > 999 && num < 100000) {
      returnValue = (num / 1000).toFixed(decimal) + 'K'; // convert to K for number from > 1000 < 1 million 
  } else if (num >= 100000 && num < 1000000) {
      returnValue = (num / 1000000).toFixed(1) + 'M'; 
  } else if (num >= 1000000) {
      returnValue = (num / 1000000).toFixed(decimal) + 'M'; // convert to M for number from > 1 million 
  } else {
      returnValue = num.toFixed(decimal); // if value < 1000, nothing to do
  }
  return (unit + (isNegative ? `(${returnValue})` : returnValue)).trim();
};

export const setTicks = (min: number, max: number) => {
  if (min < 0) {
      max = Math.max(max,Math.abs(min));
  }
  let [x, ceilValue, ticks, noType] = [0, 0, new Array(), ''];

  if ((max / 1000000) > 1) {
      x = ((max / 1000000) / 4);
      noType = 'M';
  } else if ((max / 1000 > 1)) {
      x = ((max / 1000) / 4);
      noType = 'K';
  } else {
      x = max / 4;
      noType = 'H';
  }

  if ((x / 100) >= 1) {
      ceilValue = Math.ceil(x / 100);
      ticks = getTickValues(min >= 0, 100, ceilValue, noType);
  } else if ((x / 10) >= 1) {
      ceilValue = Math.ceil(x / 10);
      ticks = getTickValues(min >= 0, 10, ceilValue, noType);
  } else {
      ceilValue = Math.ceil(x);
      ticks = getTickValues(min >= 0, 1, ceilValue, noType);
  }

  ticks = ticks.map((num: any) => {
      if (num != 0) {
          if (num.split('').pop() == 'M') {
              return Number(num.slice(0, -1)) * 1000000;
          } else if (num.split('').pop() == 'K') {
              return Number(num.slice(0, -1)) * 1000;
          } else {
              return Number(num.slice(0, -1));
          }
      } else {
          return 0;
      }
  })

  if (min >= 0) {
      let i = ticks.findIndex((tick: any) => tick > max);
      ticks = ticks.slice(0, i + 1);
      // ticks.pop();
  } else if (min < 0) {
      let t = ticks.reduce((acc: any, initial: any) => {
          if (initial < 0) {
              acc.negative.push(initial);
          } else {
              acc.positive.push(initial);
          }
          return acc;
      }, { negative: [], positive: [] });

      let i = t.positive.findIndex((tick: any) => tick > max);
      t.positive = t.positive.slice(0, i + 1);
      let y = t.negative.findIndex((tick: any) => tick > min);

      t.negative = y == -1 ? [t.negative.pop()] : t.negative.slice(y - 1);
      ticks = [...t.negative, ...t.positive];
  }
  return ticks;
};

const getTickValues = (allPositive: boolean, multiplier: number, ceilValue: number, noType: string) => {
  let res = new Array();
  if (allPositive) {
      // return 
      for (let x = 0; x <= 4; x++) {
          if (x == 0) {
              res = [...res, '0'];
          } else {
              res = [...res, ((x * multiplier * ceilValue) + noType)];
          }
      }
  } else {
      for (let x = -4; x <= 4; x++) {
          if (x == 0) {
              res = [...res, '0'];
          } else {
              res = [...res, ((x * multiplier * ceilValue) + noType)];
          }
      }
  }
  return res;
};

export default function useDebounce(value: any, delay: any) {
  const [debouncedValue, setDebouncedValue] = useState(value);

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedValue(value);
    }, delay);
    return () => {
      clearTimeout(handler);
    };
  }, [value, delay]);

  return debouncedValue;
}

export const FILTERDATA = "FILTERDATA";
export const CURRENTVIEW = "CURRENTVIEW";
export const MANAGER = "MANAGER";
export const TIMELINE = "TIMELINE";
export const APPROACH = "APPROACH";
